<div id="contentColorwebtech" class="contentHeight">
  <search
        *ngIf="references == null"
        id="search"
        class="contentHeight"
        style="display: flex; flex-direction: column; height: 100%;"
        (listResult)="search($event)"
        [colorCode]="colorCode"
        [manufacturer]="manufacturer"
        [technology]="technology"
        [searchCrit]="searchCrit">
  </search>
  <referencelist
        *ngIf="references!=null && reference == null && variants == null && biTons == null"
        id="reference-list"
        [references]="references"
        [searchCrit]="searchCrit"
        (variants)="checkVariants($event)">
  </referencelist>
  <variantelist
        *ngIf="variants !=null && reference == null && biTons == null"
        id="variante-list"
        [variants]="variants"
        (reference)="selectRef($event)"
        [searchCrit]="searchCrit">
  </variantelist>
  <multiTon
        *ngIf="biTons !=null && reference == null"
        id="multiTon"
        [biTons]="biTons"
        (reference)="selectRef($event)"
        [searchCrit]="searchCrit"></multiTon>
  <referencedetails
        *ngIf="reference!=null"
        id="reference-details"
        [reference]="reference"
        [searchCrit]="searchCrit">
  </referencedetails>  
</div>

<label class="datemaj">{{'common.majbdd'|translate}} {{dateMAJ}}</label>
